import React from 'react';
import styled from 'styled-components';
import { LabeledIconInput, DollarIcon } from '@commonsku/styles';
import { RangeFilterProps } from './types';

function stripLeadingZeroFromInput(value: string): string {
  return value.replace(/^(0+)\d/, (part) => Number(part).toString());
}

const PriceRangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const AutoWidthLabeledIconInput = styled(LabeledIconInput)`
  width: auto;
`;

const PriceRangeFilter: React.FC<RangeFilterProps> = ({
  minValue,
  maxValue,
  minPlaceholder,
  maxPlaceholder,
  onChangeMin,
  onChangeMax,
  minLabel = 'From',
  maxLabel = 'To',
}) => {
  return (
    <PriceRangeContainer>
      <div>
        <AutoWidthLabeledIconInput
          labelOnTop
          label={minLabel}
          value={stripLeadingZeroFromInput(minValue)}
          placeholder={minPlaceholder}
          Icon={<DollarIcon />}
          onChange={({ currentTarget }: React.ChangeEvent<HTMLInputElement>) => {
            if (!/^\d*$/.test(currentTarget.value)) {
              return;
            }
            onChangeMin(currentTarget.value);
          }}
        />
      </div>
      <div>
        <AutoWidthLabeledIconInput
          labelOnTop
          label={maxLabel}
          value={stripLeadingZeroFromInput(maxValue)}
          placeholder={maxPlaceholder}
          Icon={<DollarIcon />}
          onChange={({ currentTarget }: React.ChangeEvent<HTMLInputElement>) => {
            if (!/^\d*$/.test(currentTarget.value)) {
              return;
            }
            onChangeMax(currentTarget.value);
          }}
        />
      </div>
    </PriceRangeContainer>
  );
};

export default PriceRangeFilter;
